module.exports = __webpack_public_path__ + "img/1.798feaf5.png";